module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-60x60-e2eaed3a9acb26728b17f186dfaceed6.png";